import { render, staticRenderFns } from "./CasinoBalance.vue?vue&type=template&id=533f90ae&scoped=true"
import script from "./CasinoBalance.vue?vue&type=script&lang=js"
export * from "./CasinoBalance.vue?vue&type=script&lang=js"
import style0 from "./CasinoBalance.vue?vue&type=style&index=0&id=533f90ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533f90ae",
  null
  
)

export default component.exports